import { Box, PopoverMenu, Text, TextButton } from '@wix/design-system';
import { ChevronDownSmall } from '@wix/wix-ui-icons-common';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import { IMAGE_STYLES } from './../ai-image-modal/consts';

import { AI_IMAGE_MODAL_IMAGE_STYLE } from '../data-hooks';
import type { ImageStyle } from './slice/types';

type ImageStyleSelectorProps = {
  value: ImageStyle;
  onChange: (value: ImageStyle) => void;
  disabled?: boolean;
  zIndex: number;
  modalRef: HTMLDivElement | null;
};

export const ImageStyleSelector: React.FC<ImageStyleSelectorProps> = ({
  value,
  onChange,
  disabled,
  zIndex,
  modalRef,
}) => {
  const { t } = useContext(RicosContext);

  return (
    <Box direction="horizontal" gap="SP1" verticalAlign="middle">
      <Text size="small" secondary>
        {t('AIPlugin_Label_ImageStyle')}:
      </Text>
      {!!modalRef && (
        <PopoverMenu
          dataHook={AI_IMAGE_MODAL_IMAGE_STYLE}
          triggerElement={
            <TextButton disabled={disabled} size="small" suffixIcon={<ChevronDownSmall />}>
              {t(IMAGE_STYLES[value])}
            </TextButton>
          }
          textSize="small"
          maxHeight={250}
          zIndex={zIndex + 1}
          appendTo={modalRef}
        >
          {Object.entries(IMAGE_STYLES).map(([style, label]) => (
            <PopoverMenu.MenuItem
              dataHook={style}
              key={style}
              text={t(label)}
              onClick={() => {
                onChange(style as ImageStyle);
              }}
            />
          ))}
        </PopoverMenu>
      )}
    </Box>
  );
};
